<template>
<div class="wp-body" v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <header class="wp-header">
      <div class="flex flex-wrap w-full gap-2">
        <div class="w-full sm:w-52">
          <el-input
            class="w-full"
            :placeholder="$t('search')"
            prefix-icon="el-icon-search"
            v-model="search"
            @keyup.enter.native="__GET()"
          >
          </el-input>
        </div>
        <div class="flex-1"></div>
        <button
          v-if="role !== 'admin' && role !== 'supervisor'"
          class="add__button"
          @click="$router.push('/reservoir/pumpingstation/create')"
        >
          {{ $t("add_new_pumpingstations") }} <HAddCircle />
        </button>
      </div>
    </header>
        <el-table :data="resList.results" style="width: 99%;margin-bottom: 20px;" row-key="id">
            <el-table-column label="№" width="70" align="center">
                <template slot-scope="scope">
                    {{ (current_page-1)*item_count + (scope.$index + 1) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('name')" prop="name_cyr" min-width="200" >
                <template slot-scope="scope">
                    <router-link  :to="`/reservoir/pumpingstation/${scope.row.id}/1`" class="rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 text-base leading-snug w-max table-cell">{{ scope.row[`name_${$i18n.locale}`] ? scope.row[`name_${$i18n.locale}`] : scope.row.name_cyr  }}  </router-link>
                </template>
            </el-table-column>
            <el-table-column :label="$t('adress')"   prop="address" min-width="200" >
            </el-table-column>
            <el-table-column :label="$t('year_of_construction')"   prop="year_of_construction" min-width="120" >
            </el-table-column>
            <el-table-column :label="$t('date_of_accept')"   prop="date_of_accept" min-width="160" >
            </el-table-column>
            <el-table-column :label="$t('class')"   prop="reservoir_class.name_cyr"  min-width="80">
            </el-table-column>
            <el-table-column :label="$t('water_source')"   prop="water_source.name_cyr" min-width="120" >
            </el-table-column>
            <el-table-column :label="$t('finalconclusion')"   prop="finalconclusion.name_cyr" min-width="200" >
            </el-table-column>
            <el-table-column :label="$t('actions')" width="180" >
                <template slot-scope="scope">
                <div class="flex items-center gap-2">
                    <button v-if="role == 'admin' && scope.row.file"
                        type="button"
                        class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl flex items-center justify-center"
                        @click="GeneratePasport(scope.row.file)">
                        <HDocumentText/>
                    </button>
                    <button @click="$router.push({ path: `/reservoir/pumpingstation/${scope.row.id}/1` })"
                        type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
                        <HEye/>
                    </button>
                    <button v-if="role !== 'admin' && role !== 'supervisor'" @click="$router.push({ path: `/reservoir/pumpingstation/${scope.row.id}/0` })"
                        type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
                        <HEdit/>
                    </button>
                </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- <pre>{{ userList. }}</pre> -->
        <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]" :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page" :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count">
        </el-pagination>
        <el-drawer :title="$t('pumpingstation_passport')" :visible.sync="drawer" direction='rtl'>
        <div>
            <div class="pdf">
                <vue-pdf ref="print" :src="pdf"></vue-pdf>
                <div class="loading-pdf" v-show="loadDawer">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
            <div class="w-full pdf-control">
                <button class="print" @click="downloadFile(pdf)"><i class="el-icon-download mr-2"></i> {{$t('download')}}</button>
                <a :href="pdf" target="_blank">
                    <button class="ml-3 print"><i class="el-icon-view mr-2"></i> {{$t('see')}}</button>
                </a>
            </div>
        </div>

    </el-drawer>
</div>
</template>

<script>
import HAddCircle from '../Icons/hAddCircle.vue';
import HDocumentText from '../Icons/hDocumentText.vue';
import HEdit from '../Icons/hEdit.vue';
import HEye from '../Icons/hEye.vue';

export default {
    components: {
        HDocumentText,
        HEdit,
        HEye,
        HAddCircle
    },
    data() {
        return {
            pdf: '',
            namePdf: '',
            loadDawer: false,
            drawer: false,
            resList: [],
            search: '',
            page_count: 1,
            loading: false,
            userList: [],
            input2: null,
            items: [{
                message: "Foo"
            }, {
                message: "Bar"
            }],
            currentTab: 1,
            current_page: 1,
            item_count: 10,
        };
    },
    computed: {
        role() {
            return this.$store.state.role;
        },
    },
    watch:{
        role(){
            this.current_page = this.$route.query.page || 1;
            this.__GET()
        }
    },
    mounted() {
        this.current_page = this.$route.query.page || 1;
        this.__GET()
    },
    methods: {
        GeneratePasport(a) {
            this.drawer = true
            this.pdf=a
            // this.loadDawer = true
            // axios.post(`/reservoir/pumpingstation/${id}/generate/`)
            //     .then(res => {
            //         console.log(res)
            //         this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link
            //     })
            //     .catch(e => {

            //     })
            //     .finally(() => {
            //         this.loadDawer = false
            //     })
        },
        downloadFile(file) {
            fetch(file)
                .then((resp) => resp.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    // the filename you want
                    a.download = 'Pasport' || "file.json";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
        },
        paginate(val) {
            this.current_page = val;
            this.__GET()
        },
        paginateSize(val) {
            this.item_count = val
            this.__GET();
        },
        __GET() {
            this.loading = true;
            let offset = this.item_count * (this.current_page - 1);
            if(this.role=='admin' || this.role=='supervisor'){
            axios.get(`/reservoir/pumpingstation/?list=selection&limit=${this.item_count}&offset=${offset}&search=${this.search}`)
                .then((response) => {
                    this.resList = response.data;
                    this.page_count = Math.ceil(response.data.count / this.item_count);
                })
                .finally(() => {
                    this.loading = false;
                })
            }
            else{
                axios.get(`/reservoir/pumpingstation/?limit=${this.item_count}&offset=${offset}&search=${this.search}`)
                .then((response) => {
                    this.resList = response.data;
                    this.page_count = Math.ceil(response.data.count / this.item_count);
                })
                .finally(() => {
                    this.loading = false;
                })
            }
        }
    }
};
</script>

<style lang="scss" scoped>
tbody tr td:last-child {
    display: flex;
    justify-content: center;
}

ul {
    display: flex;
    margin-bottom: 20px;

    // flex-wrap: wrap;
    li {
        cursor: pointer;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: solid 1px #d4d4d4;
        font-size: 17px;
        line-height: 24px;
        color: #3730A3;
        // position: relative;
        user-select: none;

        &.active {
            border-bottom: solid 3px #3730A3;
        }
    }
}


</style>
